enum TraitsRecordCardType {
  UPDATE = 'UPDATE',
  DELETED = 'DELETED',
}

export default TraitsRecordCardType;
